import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseApplication extends BaseModel {
  static override constructorName = 'ResearchShowcaseApplication'

  fio: string = ''
  'company_name': string = ''
  phone: string = ''
  email: string = ''
  comments: string = ''
  'terms_accepted': boolean = false
  'privacy_accepted': boolean = false
  'policy_accepted': boolean = false
  'marketing_accepted': boolean = false
  status: string = ''
  'created_at': string = ''
  'updated_at': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseApplication)
